const localeMessages = { 
    'department': 'دپارتمان',
    'group': 'گروه',
    'user': "کاربر",
    'staff': "سمت",
    'help': 'راهنما',
    'error_saving':"خطا در ذخیره",
    'ok': 'تایید',
    'send_as_staff': "با سمت",
    'remove_record': "حذف رکورد",
    'apply': "اعمال تغییرات",
    'homepage': "صفحه خانه",
    'view_form': "مشاهده فرم",
    'confirm': "تایید",
    'prev_row': "سطر قبلی",
    'next_row': "سطر بعد",
    'save_and_new': "ذخیره و جدید",
    'save_and_return': "ذخیره و بازگشت",
    'cancel_and_return': "انصراف و بازگشت",
    'submit_form': "ارسال فرم",
    'return': "بازگشت",
    'save_form': "ذخیره فرم",
    'login': "ورود",
    'sign_in': "وارد شوید",
    'username': "نام کاربری",
    'password': "کلمه عبور",
    'date': "تاریخ",
    'author': "نویسنده",
    'more_details': "مشاهده جزییات بیشتر",
    'show': "نمایش",
    'close': "بستن",
    'open': "باز كردن",
    'languages': "زبان‌ها",
    'try_again': "تلاش مجدد",
    'tracking': "رهگیری",
    'tracking_code': "کد رهگیری",
    'history': "تاریخچه",
    'process_level': "مرحله فرآیند: <strong>{level}</strong>",
    'loading': "در حال بارگذاری",
    'uploading': "بارگذاری",
    'save': "ذخیره",
    'remove': "حذف",
    'attention': "* توجه:",
    'select': "انتخاب کنید.",
    'please': "لطفاً",
    'doing': "در حال اعمال ...",
    'upload_doing': "در حال آپلود و ذخیره ...",
    'page_refresh': "جهت مشاهده تغییرات یک بار صفحه را Refresh نمایید.",
    'send': "ارسال",
    'insert': "درج",
    'edit': "ویرایش",
    'are_you_sure': "آیا مطمئن هستید؟",
    'control': "کنترل",
    'show_error_details': "نمایش جزئیات خطا",
    'warning': "هشدار",
    'search': "جستجو",
    'empty': "خالي",
    'new': "جدید",
    "RowNumber":"ردیف",
    'priority': "اولویت",
    'priority_low': "پایین",
    'priority_normal': "عادی",
    'priority_high': "بالا",
    'priority_very_high': "خیلی بالا",
    'subject': 'عنوان',
    'created_date': 'تاریخ ایجاد',
    'select_date':'انتخاب تاریخ',
    'response_deadline': 'مهلت پاسخ',
    'done_date': 'تاریخ انجام',
    'sender': "فرستنده",
    'starter_user': "کاربر شروع کننده",
    'starter_staff': "سمت شروع کننده",
    'is_assignable': "قابل تخصیص",
    'forward': "ارجاع",
    'insert_label': "افزودن برچسب",
    'continue': "ادامه",
    'other': 'سایر',
    'settings': 'تنظیمات',
    'change_theme': 'تغییر تم',
    'messages': 'پیام ها',
    'all_messages': 'مشاهده همه پیام‌ها',
    'new_message': 'ارسال پیام',
    'message':'پیام',
    'messages_sent': 'پیام های ارسالی',
    'messages_receive': 'پیام های دریافتی',
    'messages_receive_notification':'شما یک پیام جدید دارید !',
    'sign_out': 'خروج',
    'first-page': 'صفحه ی نخست',
    'view-form': 'نمایش فرم',
    'change_password': 'تغییر کلمه ی عبور',
    'invalid_date': "تاريخ معتبر نمي باشد!",
    'save_successfully': "ذخیره با موفقیت انجام شد.",
    'operation_faild': "عمليات با خطا مواجه شد.",
    'session_end_you_will_redirect_to_the_homepage': "زمان جلسه شما به اتمام رسید؛ شما به صفحه خانه هدایت میشود.",
    'process_tree': "درختواره تاریخچه",
    'process_graph': "گراف تاریخچه",
    'print_form': "چاپ فرم",
    'time_sheet': "تايم شيت",
    'assign': "ارجاع",
    'word_output': "خروجی Word",
    'pdf_output': "خروجی PDF",
    'word_print': "چاپ Word",
    'report': "گزارشات",
    'pdf_download': "دانلود فایل PDF : ",
    'select_file': "انتخاب فایل :",
    'send_pdf': "ارسال فایل pdf",
    'by_level': "با سمت:",
    'view_all_staff': 'مشاهده همه سمت‌ها',
    'image': 'تصویر',
    'of': 'از',
    'new_task':'کار جدید',
    'more_items': 'موارد بیشتر...',
    'has_form_less_events': 'دارای رخدادهای بدون فرم',
    'retrieve-data-error': "خطا در بازیابی اطلاعات!",
    'upload_pdf_file': "ارسال فایل PDF_en",
    'download_pdf_file': "دریافت فایل PDF_en",
    'export': "خروجی",
    'not_selected': "انتخاب نشده",
    'news_detaile': "جزئیات خبر",
    'password_setting': {
        'current_password': 'کلمه عبور فعلی',
        'new_password': 'کلمه عبور جدید',
        'confirm_new_password': 'تکرار کلمه عبور جدید',
        'messages': {
            'current_password_is_wrong': "رمز عبور فعلی اشتباه است!",
            'passwords_do_not_match': "تکرار کلمه ی عبور جدید یکسان نیست!",
            'currentPassword_is_empty': "کلمه ی عبور فعلی خالی است!",
            'newPassword_is_empty': "کلمه ی عبور جدید خالی است!",
            'confirmNewPassword_is_empty': "تکرار کلمه ی عبور جدید خالی است!",
        },
    },
    'session_end_title': 'اتمام زمان کار با سامانه',
    'login_again': 'لطفاً مجدد وارد شوید.',
    'error':'خطا',
    'submit': 'بلی',
    'cancel': 'خیر',
    'cancel_nested': "انصراف",
    'title': {
        'news': "اخبار و تازه ها",
        'announcements': "اعلان‌ها و اطلاعیه‌ها",
        'procces_history': "تاریخچه فرآیند",
        'audit':'مدیریت تنظیمات audit'
    },
    'search_panel_control': {
        'filter': "فیلتر",
        'clear_filter': "بدون فیلتر"
    },
    'grid_control': {
        'add': "افزودن",
        'edit': "ویرایش",
        'del': "حذف",
        'export_excel': "خروجی Excel",
        'save': "ذخیره",
        'cancel': "انصراف",
        'view': "نمایش",
        'export': "خروجی",
        'grid_is_in_editing_mode': "در حالت ویرایش است، لطفاً ابتدا آن‌را ذخیره کنید.",
        'grid_is_in_editing_mode_you_cannot_do_anything': "فرم در حال ويرايش است، امکان انجام عمليات ديگری وجود ندارد.",
        'no_rows_selected': "هیچ سطری انتخاب نشده است.",
        'remove_selected_row': "آیا از حذف سطر انتخاب شده مطمئن هستید؟",
        'only_selected_columns_will_be_exported': 'خروجی شامل ردیف و ستون های انتخابی میباشد',
        'items_get_error': "خطا در دريافت اطلاعات گريد"

    },
    'attachment_control': {
        'add': "افزودن",
        'new': "جدید",
        'select': "موجود",
        'scan': "اسکن",
        'new_version': "نگارش جدید",
        'delete': "حذف",
        'revert': "بازگشت تغییرات",
        'edit': "ویرایش",
        'download': "دریافت",
        'downloadall': "دریافت همه",
        'noFileExists': "فایلی موجود نیست",
        'select_file': 'انتخاب فایل',
        'upload_file': 'بارگذاری فایل',
        'upload_cancel': 'انصراف از بارگذاری',
        'messages': {
            'folder_default_not_found': "مقدار مناسبی برای پوشه پیش فرض انتخاب نشده است",
            'delete_file': "آيا از حذف اين فايل مطمئن هستيد؟",
            'save_Changes': "تغییرات با موفقیت انجام شد!",
            'error_try_again': "در انجام عملیات خطایی رخ داد، لطفاً مجدد تلاش فرمایید.",
            'file_edit_dont_allow': "امکان ویرایش این نوع فایل وجود ندارد!",
            'desktop_file_launcher_notFound': "کاربر گرامی سرویس اجرای فایل رایورز در حال اجرا نمی باشد لطفا جهت اجرا آن را از<a href='FileLuncher/FileLauncherSetup.exe' style='font-weight: bold;'>  اینجا <a/>  دریافت و نصب نمایید.",
            'reverted_Successfully': "بازگشت تغییرات با موفقیت انجام شد",
            'file_upload_count_error': 'امكان بارگذاري فايل ديگري نمي باشد!',
            'default_file_delete_error': 'حذف فايل هاي پيش فرض امكان پذير نمي باشد!',
            'default_file_edit_error': 'فایل انتخابی فایل پیشفرض است و قابل ویرایش نیست!',
            'file_type_error': "نوع فایل صحیح نمی باشد",
            'scan_upload_error': "عملیات اسکن با مشکل مواجه شد!",
            'scan_service_error': "سرویس اسکنر یافت نشد!",
            'select_file_error': "لطفاً فايل موردنظر را انتخاب نماييد!",
            'file_edit_error': "فایل ذخیره نشده است!",
            'file_upload_successfully': 'فایل انتخاب شده با موفقیت به کنترل الصاق اضافه گردید',
            'file_size_error': "اندازه فایل بیشتر از حد مجاز می باشد ",
            'file_repeat_name_error': "نام فایل تکراری می باشد و قابل افزودن نیست !",
            'file_select_count_error': "تعداد فایل های انتخابی بیشتر از حد مجاز می باشد!",
            'file_upload_error': "امكان بارگذاري  فایل انتخابی نمی باشد!",
            'file_name_repeated_by_param': " فایلی با نام  {repeatedName} تکراری می باشد و قابل افزودن نیست ",
            'scan-opration-encountered-problem': "عملیات اسکن با مشکل مواجه گردید!",
            'file_is_in_edit_mode': "فایل در حالت ویرایش است ",
            'dont_allow_edit_file': "امکان ویرایش این نوع فایل وجود ندارد.",

        }
    },
    'export_control': {
        'title': 'نوع خروجي را انتخاب کنيد',
        'titlesetting': 'تنظیمات عنوان',
        'showTableTitle': 'نمایش عنوان جدول در خروجی',
        'backGround': 'پس زمینه',
        'fontname': 'نوع متن',
        'fontsize': 'اندازه متن',
        'fontcolor': 'رنگ متن',
        'borderstyle': 'نوع حاشیه',
        'bordercolor': 'رنگ حاشیه',
        'columnsetting': 'تنظیمات سرستون ها',
        'cellsetting': 'تنظیمات سلول',
        'createfile': 'ایجاد فایل',
        'bodysetting': 'تنظیمات بدنه',
        'exit': 'خروجی',
        'columnfontstyle': 'فرمت متن برای  ستون',
        'context': 'متن',
        'contextstyle': 'فرمت متن',
        'date': 'تاریخ',
        'twodigit': 'عدد تا 2 رقم اعشار',
        'fourdigit': 'عدد تا 4 رقم اعشار'
    },
    'chart_control': {
        'error_in_Get_Data': 'خطا در دريافت اطلاعات نمودار ===>',
        'updating_chart': "در حال به روز رساني نمودار...",
        'updating_map': "در حال به روز رساني نقشه...",
        'error_in_get_map_data': 'خطا در دريافت اطلاعات نقشه ===>'

    },
    'assign_control': {
        'no_name': "بدون عنوان",
        'delete': "حذف",
        'messages': {
            'item_is_repeated': "آیتم {displayMember} قبلاً در لیست اضافه شده است."
        }
    },
    'comment_control': {
        'delete_confirm': "آیا از حذف این مورد اطمینان دارید؟",
        'back': "بازگشت",
        'save':"ذخیره"
    },
    'tree_control': {
        'expand_collapse': "گسترش/بسته",
        'error': "خطا",
        'warning': "هشدار",
        'add_new': "افزودن مورد جدید",
        'show': "نمایش",
        'edit': "ویرایش",
        'delete': "حذف",
        'messages': {
            'item_delete_confirm': "آیا از حذف رکورد انتخاب شده مطمئن هستید؟",
            'item_get_info_error': "خطا در دريافت اطلاعات درخت ",
        }
    },
    'dropdown_control': {
        'select': "انتخاب...",
        'messages': {
            'items_get_error': "خطا در دریافت اطلاعات! "
        }
    },
    'context': {
        'new_folder': "پوشه جديد",
        'edit_folder': "ويرايش پوشه",
        'delete_folder': "حذف پوشه",
        'open_in_new_window': "باز كردن در پنجره جديد",
        'rules': "مديريت قوانين پوشه",
        'messages': "پیام ها",
        'send_message': "ارسال پیام",
        'view_received_messages': "مشاهده پیام های دریافتی",
        'view_sent_message': "مشاهده پیام های ارسالی",
    },
    "cartable_grid": {
        'open_in_new_window': "باز كردن در پنجره جديد",
        'history': "تاریخچه",
        'tree_history': "درختواره",
        'graph_history': "گراف",
        'time_sheet': "تایم شیت",
        'change_folder': "تغییر پوشه",
        'flag': "نشانه",
        'no_flag': "بدون نشانه",
        'assignTask': "ارجاع",
        'FolderService_CanNotTransfer': "امکان انتقال به این پوشه وجود ندارد.",
        'total_tasks': 'تعداد کل کارها در این پوشه :',
        'total_unread_tasks': 'تعداد کارهای خوانده نشــده: ',
    },
    'create_physical_folder': {
        'add_modal_header': 'ایجاد پوشه',
        'edit_modal_header': 'ویرایش پوشه',
        'folder_title': 'عنوان پوشه',
        'folder_type': 'نوع پوشه',
        'dont_send_request':'درخواست های ارسال نشده',
        'undone_works': 'کارهای انجام نشده',
        'done_works': 'کارهای انجام شده',
        'folder_title_empty': "عنوان پوشه خالیست",
        'folder_title_length_error': "تعداد کاراکترهای عنوان نمی تواند بیش از 50 کاراکتر باشد",
        'folder_title_validate_error': "استفاده از این نام برای پوشه مجاز نیست.",
    },
    'footer': {
        'powered_by_raybpms': "سیستم مدیریت کسب و کار رایورز",
        'rights': "تکثیر 1398، کلیه حقوق مادی و معنوی این اثر محفوظ و متعلق به شرکت مهندسی نرم افزار رایورز می‌باشد.",
        'url':"https://rayvarz.com"
    },
    'messages': {
        'not_any_record_found': "رکوردی یافت نشد.",
        'not_history_for_tracking_code_found': "تاريخچه اي براي نمايش موجود نمي باشد!",
        'not_selected_principals': "هیچ فرد/گروه/سمت جهت تغییر نام پوشه انتخاب نشده است.",
        'write_dont_work_folder_name': "لطفاً نام برای پوشه کارهای انجام نشده وارد کنید.",
        'write_done_work_folder_name': "لطفاً نام برای پوشه کارهای انجام شده وارد کنید.",
        'write_dont_send_request_folder_name': "لطفاً نام برای پوشه درخواست‌هاي ارسال نشده وارد کنید.",
        'save_attntion': "آیا از اعمال تغییرات اطمینان دارید؟",
        'changing_name': "در حال تغییر نام ...",
        'sucsses_message': "ذخیره تغییرات با موفقیت انجام شد.",
        'file_volume': "حجم فایل",
        'file_upload': "نباید از 300 کیلوبایت بیشتر باشد.",
        'file_type': " فایل با پسوند jpg، png , gif وارد نمایید",
        'delete_sucsses': "با موفقیت حذف گردید",
        'reset_confirm': "آیا از بازگردانی تصویر پشت زمینه به تصویر پیشفرض اطمینان دارید؟",
        'doing_sucsses': "با موفقیت انجام شد.",
        'file_type_attention': "فقط فایل‌های gif، png و jpg پشتیبانی می‌شوند.",
        'delete_confirm_massage': "آیا از حذف اطمینان دارید؟",
        'your_request_has_been_sent': "درخواست شما با موفقیت ارسال شد.",
        'confirm_message': "آيا مطمئن هستيد؟",
        'save_successfully': "ذخیره شد.",
        'password_not_currect': "نام کاربری یا کلمه ی عبور درست نمی باشد.",
        'connection_not_safe': "ارتباط امن نیست.",
        'pleas_try_later': "لطفا دوباره امتحان کنید.",
        'username_or_password_is_null': "نام کاربری یا کلمه ی عبور خالی می باشد.",
        'control_behavior_not_exists': "رفتار فرم برای کنترل موجود نمی باشد.",
        'folder_title_length_error': 'تعداد حروف بیش از 50 است'
    },
    'Lock': {
        'bpms-lock-expired': "تاریخ اعتبار قفل به پایان رسیده است!",
        'maximum-bpms-lock-user': "تعداد کاربر همزمان به حداکثر تعداد کاربر تعریف شده در قفل رسیده است!",
        'bpms-lock-failed': "قفل براي اين سيستم وجود ندارد!",
    },
    'errors': {
        'tracking_failed': "خطا در رهگیری!",
        'tracking_code_is_empty': "کد رهگیری را وارد کنید.",
        'error_on_delete': "متاسفانه در زمان حذف خطایی رخ داد.",
        'please_select_pdf_file': "لطفاً فایل PDF را انتخاب کنید.",
        'operation_is_not_allowed': "اقدامی امکان پذیر نمی‌باشد.",
        'events_cannot_be_loaded': "خطا در بارگذاری رویداد ها!",
        'server_error': "خطای سرور",
        'you_are_not_allowed_to_view_form': "شما مجاز به مشاهده فرم نیستید.",
        'access_denied': "عدم دسترسی مجاز",
        'print_failed': 'پرینت با مشکل مواجه شد',
        'error_occured': 'خطایی رخ داد لطفاً با Administrator تماس بگیرید.'
    },
    'slider_managment': {
        'title': "تصاویر اسلایدر",
        'slider_show_is_repeat': "ترتیب نمایش تکراری وجود دارد.",
        'slider_show_is_empty': "ترتیب نمایش خالی وجود دارد.",
        'upload_message': "تعداد تصاویر انتخابی بیش از حد مجاز است!",
        'image_displaying': "ترتیب نمایش",
        'same_name_massage': "تصویر هم نام وجود دارد!",
        'image_is_too_large': "حجم تصویر انتخابی بیش از حد مجاز است!",
        'name': "نام",
        'image': "تصویر",
        'pic_type': "یک فایل تصویری jpg,png و gif با حجم کمتر از 80 کیلوبایت و در ابعاد 1140 در 225 پیکسل.",
        'image_required': 'لطفا تصویر را انتخاب نمائید',
        'level_required': 'لطفا ترتیب نمایش  را انتخاب نمائید',
        'new': 'افزودن تصویر اسلایدر',
        'edit': 'ویرایش',
        'empty': 'خالی'
    },
    'cartable_management': {
        'cartable_managment_title': "مدیریت کارتابل - تغییر نام پوشه های پیشفرض",
        'cartable_date_setup': "تنظیمات تاریخ در کارتابل",
        'status': "حالت :",
        'exact': "دقیق",
        'limited': "حدودی",
        'exact_dsc': "نمایش تاریخ به همراه ساعت",
        'limited_dsc': "نمایش به صورت تعداد روزهای قبل",
        'select_person': "انتخاب فرد، سمت یا گروه جهت تغییر نام پوشه‌های اصلی:",
        'dont_works': "پوشه کارهای انجام نشده:",
        'done_work': "پوشه کارهای انجام شده:",
        'dont_send_request': "درخواست‌هاي ارسال نشده:",
        'changing_folder_name': "تغییر نام پوشه ها",
        'attention_message': " جهت مشاهده تغییرات اعمال شده نیاز است تا کاربر یکبار از سیستم خارج و مجدد وارد شود.",
        'tree_expanded': "در زمان لاگین، پوشه کارهای انجام نشده اولین سمت انتخاب شود.",
        'hide_default_user_folders': 'مخفی کردن پوشه‌های سیستمی کاربر در کارتابل',
        'tree': "درختواره پوشه‌ها",
        'expand_folders_by_default': 'باز کردن تمام پوشه های کاربر و سمت به صورت پیشفرض',

    },
    'vacation_calendar_management': {
        'vacation_calendar_title': "تعطیلات سال",
        'year': "سال مورد نظر: ",
        'show_calendar': "نمایش تقویم",
        'year_calendar': "تقویم سال",
        'messages': {
            'year_validate_message': "سال وارد شده معتبر نمی باشد."
        }
    },
    'appearance_management': {
        'ui_setup': "تنظیمات ظاهر",
        'back_image': "تصویر پشت زمینه",
        'default_theme': "تِم پیشفرض میزکار",
        'banner': "بنر بالا",
        'back_image_dsc': "جهت انتخاب تصویر پشت زمینه برای صفحه قبل و بعد از لاگین میتوانید از فرم زیر استفاده نمایید.",
        'default_theme_dsc': "لطفاً یکی از تِم‌های زیر را جهت انتخاب به عنوان تِم پیشفرض میزکار انتخاب نمایید.",
        'banner_dsc': "جهت انتخاب بنر برای سایت از فرم زیر جهت آپلود اقدام نمایید.",
        'before_login': "تصویر قبل لاگین:",
        'after_login': "تصویر بعد لاگین:",
        'current_img': "تصویر فعلی",
        'location': "محل قرارگیری:",
        'repeat': "تکرار",
        'no_repeat': "بدون تکرار",
        'center': "وسط",
        'back_color': "رنگ پس زمینه",
        'upload_save': "آپلود و ذخیره",
        'select_theme': "تم مورد نظر",
        'preview': "پیش‌نمایش قالب",
        'set_theme': "اعمال قالب",
        'banner_attention': "لطفاً قبل از انتخاب فایل جهت آپلود به موارد زیر دقت فرمایید:",
        'height_attention': "حداکثر ارتفاع هر فایل بیشتر از 149 پیکسل نباشد.",
        'image_attention': "ارتفاع تصویر پیش‌زمینه بنر حتماً 149 پیکسل باشد.",
        'back_image_file': "فایل تصویر پیش‌زمینه بنر:",
        'right_iamge': "تصویر سمت راست:",
        'center_image': "تصویر مرکزی:",
        'left_image': "تصویر سمت چپ:",
        'for_field': "برای فیلد",
        'select_image_file': "لطفاً یک فایل تصویر",
        'delete_current_banner': "حذف بنر فعلی",
        'image_restore': "بازگردانی عکس پیشفرض",
        'select_theme_for_current_user': "انتخاب تِم برای کارتابل کاربر جاری",
        'file_type': "تنها تصاویر gif، png و jpeg پیشتیبانی میشوند."

    },
    'home_menu_management': {
        'message': {
            'home_ui_save_confirm': "آیا از اعمال تنظیمات اطمینان دارید؟\r\n***فقط اندازه تصویر، شکل آیکن، محل قرارگیری و رنگ متن اعمال میشود.",
            'save_sucsses_all': "تنظیمات برروی همه اعمال شد.",
            'save_confirm': "آیا از اعمال تنظیمات اطمینان دارید؟",
            'save_sucsses': "با موفقیت تنظیمات اعمال شد.",
            'insert_number': "برای اندازه آیکن/تصویر فقط عدد می‌توانید وارد کنید.",
            'icon_size': "اندازه آیکن/تصویر باید بین 25 الی 140 باشد.",
            'file_type': "تنها تصاویر gif، png و jpeg پیشتیبانی میشوند.",
            'icon_volume': "حجم آیکن/تصویر نباید از 30 کیلوبایت بیشتر باشد."

        },
        'home_ui_setting': "تنظیمات صفحه خانه",
        'items_menu': "منو آیتم‌ها",
        'description': "لطفاً جهت اضافه کردن منوها به صفحه خانه؛ هر آیتمی را که میخواهید انتخاب و تنظیمات آنرا انجام دهید.",
        'menu_setting': "تنظیمات آیتم منو",
        'show_menu': "نمایش منو در صفحه خانه",
        'first_level': "نمایش در سطح اول",
        'not_show_top': "عدم نمایش در منوی بالا",
        'display_name': "نام نمایشی",
        'icon_width': "عرض آیکن",
        'icon_width_ph': "اندازه عرض آیکن/تصویر",
        'icon_height': "طول آیکن",
        'icon_height_ph': "اندازه طول آیکن/تصویر",
        'home_menu_icon': "آیکن/تصویر منو در خانه",
        'select_file': "لطفاً یک فایل jpg، png یا gif انتخاب نمایید.",
        'icon_view': "شکل آیکن/تصویر",
        'circul': "دایره‌ای",
        'squared': "مربعی",
        'rectangle': "مستطیل",
        'text_location': "محل قرارگیری متن",
        'up_image': "بالا تصویر",
        'center_image': "وسط تصویر",
        'bottom_image': "پایین تصویر",
        'up_text': "متن بالا",
        'center_text': "متن وسط",
        'bottom_text': "متن پایین",
        'delete_image': "حذف تصویر",
        'text_color': "رنگ متن",
        'float_text_color': "رنگ متن: حالت شناور",
        'hilight_text_color': "رنگ متن: حالت هایلایت",
        'save_button_title': "همه تنظیمات به غیر از تصویر ، نام نمایشی، بودن در منو",
        'doing_settup': "اعمال تنظیمات بالا برای همه",
        'check_mark': "در صفحه خانه نمایش داده میشود",
        'published_date': 'منتشر شده در:'

    },
    'news_management': {
        'message': {
            'insert_title': "لطفاً عنوان را وارد کنید.",
            'title_character_length': "طول عنوان نباید از 255 کارکتر بیشتر باشد.",
            'text_character_length': "طول متن نباید از 4000 کارکتر بیشتر باشد.",
            'insert_text': "لطفاً متن را وارد نمایید.",
            'number_priority': "اولویت فقط از نوع عددی باید باشد.",
            'number_large': "عدد وارد شده برای اولویت خبر از 4 رقم بیشتر است.",
            'file_volume': "حجم فایل باید کمتر از 100 کیلوبایت باشد."
        },
        'news': "اخبار/اعلانات",
        'add': "جدید",
        'title': "عنوان",
        'text': "متن",
        'text_color': "رنگ متن",
        'enable_show': "قابل نمایش برای کاربران عمومی",
        'news_setup': "تنظیمات اخبار",
        'news_image': "تصویر خبر",
        'news_priority': "اولویت خبر",
        'current_pic': "مشاهده تصویر آپلود شده",
        'delete_curr_pic': "حذف تصویر فعلی",
        'pic_type': "یک فایل تصویری jpg,png و gif با حجم کمتر از 100 کیلوبایت.",
        'id': "شناسه",
        'title': "عنوان",
        'createdAt': "تاریخ درج",
        'username': "نام کاربری",
        'control': "کنترل",

    },
    'message_management': {
        'messages': {
            'repeated_recipient': "گیرنده تکراریست",
            'title_is_empty': "عنوان پیام خالی است. ادامه می دهید؟",
            'success_send': "پیام با موفقیت ارسال شد",
            'unselected_recipient': "گیرنده ای برای پیام مشخص نشده است.",
        },
        'reply_message': "پاسخ به پیام",
        'title': "عنوان :",
        'message_text': "متن پیام :",
        'attachment': "پیوست ها",
        'recipients': "گیرندگان",
        'select': "انتخاب ...",
        'add_to_list': "افزودن به لیست",
        'back': "بازگشت",
        'sended': "پیام ارسال شده ",
        'sended_by': "ارسال شده توسط :",
        'send_date': "تاریخ ارسال :",
        'message_show': "نمایش پیام",
        'no_permission': "دسترسی لازم را ندارید!",
        'subject': "موضوع",
        'date_time_send': "تاریخ و زمان ارسال",
        'sender': "فرستنده",
        'receiver': "گیرنده",
        'menu_title': "پیام‌ها"
    },
    'task_assign': {
        'messages': {
            'success_assign': "ارجاع با موفقيت انجام شد.",
            'unselected_recipient': "گيرنده اي انتخاب نشده است.",
        },
        'assign': "ارجاع",
        'recipients': "گیرنده: (لیست افرادی که کار به آنها ارجاع می شود)",
        'description': "شرح",
        'last_dsc': "شرح قبلی استفاده شود",
        'out_work': "کار از کارتابل جاری خارج شود"
    },
    'process_log': {
        'status': "وضعیت",
        'event': "رخداد",
        'user': "کاربر فرستنده",
        'user_position': "سمت فرستنده",
        'work_title': "عنوان کار",
        'responsible': "مسئول کار",
        'create_date': "تاریخ ایجاد کار",
        'done_date': "تاریخ انجام کار",
        'folder_name': "نام پوشه",
        'start_task': "فعاليت آغازين",
        'human_task': "فعاليت انساني",
        'fork_task': "فعاليت چنگالي",
        'join_task': "فعاليت تركيبي",
        'system_task': "فعاليت سيستمي",
        'common_task': "فعاليت عمومي"
    },
    'timesheet_register': {
        'messages': {
            'time_reng': "زمان شروع نمي تواند از زمان پایان بزرگتر باشد",
            'select_row': "لطفا يك سطر را انتخاب كنيد.",
            'delete_timesheet_confirm': "آیا تایم شیت جاری حذف شود؟",
            'save_time_confirm': "اين بازه زماني براي كار ديگري ثبت شده است. آيا مايل به ثبت آن براي كار جاري هستيد؟",
            'can_not_edit': "اين بازه زماني براي كارتكميل شده ديگري ثبت شده است.امكان ويرايش وجود ندارد",
            'date_not_valid': "تاریخ معتبر نمی باشد"
        },
        'errors': {
            'error_in_remaining_time': "خطا در بروز آوري زمان باقيمانده",
            'get_timesheet': "خطا در گرفتن تایم شیت",
            'error_in_save': "خطا در ذخيره",
            'error': "خطا",
            'error_in_delete': "خطا در حذف",
        },
        'work_dsc': "شرح كار",
        'date': "تاريخ",
        'start_time': "زمان شروع",
        'end_time': "زمان پايان",
        'remaining_time': "زمان باقيمانده",
        'description': "شرح",
        'timesheet': "تایم شیت",
        'current_work': "اختصاص به كار جاري",
        'persian_date': "تاريخ فارسي",
        'weekly_plan': "برنامه هفتگي",
        'prev_week': "هفته قبل",
        'next_week': "هفته بعد",
        'plus': "اضافه",
        'all_work': "تمامي فعاليت هاي كار جاري",
        'delete': "حذف"

    },
    'delegation_management': {
        'messages': {
            'select_user': "لطفا کاربر جانشین را مشخص نمایید.",
            'select_date': "تاریخ شروع و پایان را مشخص نمایید",
            'select_folder': "پوشه هایی که جانشین به ان دسترسی دارد را مشخص نمایید",
            'compare_fromDate_toDate' : "تاریخ پایان از تاریخ شروع بزرگتر است"
        },
        'folder_to_delegate': 'پوشه‌هایی که جانشین به آن دسترسی دارد',
        'delegations': "جانشین ها",
        'delegation_edit': "ویرایش جانشین",
        'delegation_user': "کاربر جانشین:",
        'all_time': "به شکل دائمی",
        'from_date': "تاریخ شروع:",
        'to_date': "تاریخ اتمام:",
        'start_date': "تاریخ شروع",
        'finish_date': "تاریخ اتمام",
        'delegate_to': "جانشین به",
        'more_item': "نمایش موارد بیشتر",
        'all_item': "نمايش تمامي موارد",
        'remove_delegate': "حذف جانشین",
        'delegation_create': "افزودن جانشین جدید",
        'no_records': 'سطری یافت نشد',
        'delegation_add': "جانشین جدید",
        'delegation_user_placeholder':"برای جستجو تایپ کنید"
    },
    'rule_criterias': {
        'new_rule': "ساخت قانون جدید",
        'edit_rule': "ویرایش قانون",
        'no_permission': "دسترسی لازم را ندارید!",
        'tag_error': "خطا در بروزرساني برچسب!",
        'flag_error': "خطا در بروزرساني نشانه!",
        'no_actions': "بدون عملیات!",
        'action': "عملیات",
        'rule_name': "نام قانون",
        'new_rule': "قانون جدید",
        'operation': "عملیات",
        'rule_name': "نام قانون",
        'select_folder': "انتخاب پوشه",

    },
    'ray_payment': {
        'messages': {
            'close_pay_win': "لطفا ابتدا پنجره پرداخت را ببندید!"
        },
        'wait_status': "منتظر تکمیل نهائی خرید",
        'payed_status': "پرداخت شده",
        'failed_status': "خطا در پرداخت",
        'not_payed_status': "پرداخت نشده",
        'currency': " ريال",
        'through': "از طریق",
        'pay': "پرداخت"
    },
    'ray_datetimepicker': {
        'date_not_valid': "تاريخ نامعتبر مي باشد!",
        'time_not_valid': "زمان وارد شده نامعتبر مي باشد!"
    },
    'logs_management': {
        'show_details': "نمایش جزئیات خطا به کاربر - با فعال بودن این گزینه؛ در خروجی وقتی خطایی رخ دهد جزئیات نمایش داده خواهد شد.",
        'error_number': "شماره",
        'date': "تاریخ",
        'level': "سطح",
        'staff_id': "شناسه سمت",
        'application_name': "برنامه",
        'error_log': "مدیریت خطاها",
        'error_message': 'خطا'
    },
    'Audit_management': {        
        'id': "شماره",
        'date': "تاریخ",
        'audit_type': "نوع",
        'user_name': "نام کاربری",
        'message': "پیغام",
        'audit_log': "مدیریت لاگ ها",
        'from_date': "نمایش لاگ از تاریخ",
        'to_date': "تا تاریخ",
        'search': "جستجو",
    },
    'rule_management': {
        'title': 'مديريت قوانين پوشه ها',
        'operation': 'عملیات',
        'rule_name': 'عنوان قانون',
        'add_new_rule': 'قانون جدید',
        'edit_rule': 'ویرایش قانون',
        'are_you_sure': 'آيا از حذف قانون مطمئن هستيد؟',
        'rule_modal': {
            'name': 'عنوان قانون',
            'subject': 'موضوع',
            'task_type': 'نوع',
            'create_date': 'تاریخ ایجاد',
            'response_date': 'مهلت پاسخ',
            'done_date': 'تاریخ انجام',
            'priority': 'اولویت',
            'flag': 'نشانه',
            'read': 'خوانده شده',
            'transcript': 'رونوشت',
            'app': 'برنامه کاربردی',
            'in_folder': 'قرار بگیرد در پوشه',
            'not_selected_option': 'انتخاب نشده',
            'validation': {
                'name' : 'عنوان قانون الزامی است'
            },
            'clear_tooltip':'پاک کردن'
        }
    },
    'session_managment': {
        'code': 'کد',
        'cell_title': 'عنوان',
        'title':'مدیریت زمان نشست ها',
        'timeout': 'زمان نشست',
        'according_to': 'براساس',
        'session_value_can_not_null':'مدت زمان جلسه نمی تواند خالی باشد.',
        'session_value_is_not_valid': 'مقدار وارد شده معتبر نیست.'
    },
    'auditconfig_managment': {
        'audit_config':'تنظیمات Audit',
        'audit_type': 'نوع audit',
        'inf_val': 'InfVal',
        'id': 'Id',
        'audit_type_required': 'نوع audit باید وارد شود.',
        'inf_val_required': 'InfVal باید وارد شود.',
        'id_required': 'Id باید وارد شود.',
        'audit_type_description': 'مواردی که برای آنها در پایگاه داده Audit لاگ ثبت می شود.',
        'inf_val_description': 'در صورتی که  مقدار این ستون برای هر مورد از AuditType برابر یک شود، لاگ در پایگاه داده ثبت می شود و در صورتیکه مقدار صفر شود، لاگ ثبت نمی شود',
        'id_description': 'Id هر AuditType مشخص شده و از آن در پایگاه داده Audit  استفاده شده است.',
        'add': "جدید",
        
    }
};

export default localeMessages;
